import { useEntryPriceAfterSpread } from '@ui/features/Trade/hooks/useEntryPriceAfterSpread';
import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { useIsNeedTokenApproval } from '@ui/hooks/useErc20Read';
import { useGasFee } from '@ui/hooks/useGasFee';
import { useEstimateOpenLimitGasLimit } from '@ui/services/contract/hooks/TradingPortalFacet/useEstimateOpenLimitGasLimit';
import { OrderType } from '@ui/types/trade';
import { useEffect } from 'react';

import { useOpenLimitOrderParams } from '../../TradeModuleConfirm/hooks/useOpenLimitOrderParams';
import { useIsConfirmBtnDisabled } from '../hooks/useIsConfirmBtnDisabled';
import { useCollateralToken } from '../store/useCollateralToken';
import { useOrderType } from '../store/useOrderType';

// native token
export const useCalcEstOpenLimitGasFee = () => {
  const inputAmount = useFromInput((s) => s.input).value.token;
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const entryPrice = useEntryPriceAfterSpread();
  const payTokenPrice = usePayTokenPriceLatest(payToken);
  const isNeedTokenApproval = useIsNeedTokenApproval({
    tokenAddress: payToken?.address,
    requiredAmount: inputAmount,
  });
  const [isConfirmBtnDisabled] = useIsConfirmBtnDisabled();
  const openLimitOrderParams = useOpenLimitOrderParams();
  const orderType = useOrderType((s) => s._persistValue);
  const isMarket = orderType === OrderType.MARKET;

  const { data: estimateOpenLimitGasLimit, refetch } = useEstimateOpenLimitGasLimit({
    openLimitOrderParams,
    opts: {
      enabled:
        !isMarket && // only fetch when is limit
        !isConfirmBtnDisabled &&
        !!entryPrice &&
        !!payTokenPrice &&
        !!openLimitOrderParams &&
        !!isNeedTokenApproval &&
        !isNeedTokenApproval.data, // only fetch when the token is approved
    },
  });

  useEffect(() => {
    const h = setTimeout(() => {
      if (!isMarket) {
        refetch();
      }
    }, 100);
    
return () => clearTimeout(h);
  }, [inputAmount]);

  const { data: gas } = useGasFee(estimateOpenLimitGasLimit);
  
return {
    gas: gas,
    refetch,
  };
};
